import 'react';
import { jsx } from '@emotion/core';
import useDocumentsAppConfigs from "../hooks/useDocumentsAppConfigs.js";
import { Button, Icon } from '@appfolio/react-gears';
import { observer } from 'mobx-react';
import useStores from "../hooks/useStores.js";

function MobilePdfToolbar() {
  var _useStores = useStores(),
      pdfStore = _useStores.pdfStore;

  var _useDocumentsAppConfi = useDocumentsAppConfigs(),
      currentUserId = _useDocumentsAppConfi.currentUserId,
      currentUserPermissions = _useDocumentsAppConfi.currentUserPermissions;

  var nextField = pdfStore.nextField(currentUserId, currentUserPermissions);
  var prevField = pdfStore.previousField(currentUserId, currentUserPermissions);
  return jsx("div", {
    className: "d-flex"
  }, jsx(Button, {
    className: "m-0 flex-grow-1 rounded-0",
    color: "primary",
    disabled: !prevField,
    size: "lg",
    onClick: function onClick() {
      if (prevField) pdfStore.focusField(prevField);
    } // This makes it so that clicking the button twice quickly doesn't
    // cause the page to zoom in.
    ,
    style: {
      touchAction: 'manipulation'
    }
  }, jsx(Icon, {
    className: "mr-2 me-2",
    name: "angle-left",
    size: "lg",
    style: {
      position: 'relative',
      top: '1px'
    }
  }), "Prev Field"), jsx(Button, {
    className: "m-0 flex-grow-1 rounded-0",
    color: "primary",
    size: "lg",
    disabled: !nextField,
    onClick: function onClick() {
      if (nextField) pdfStore.focusField(nextField);
    } // This makes it so that clicking the button twice quickly doesn't
    // cause the page to zoom in.
    ,
    style: {
      touchAction: 'manipulation'
    }
  }, "Next Field", jsx(Icon, {
    className: "ml-2 ms-2",
    name: "angle-right",
    size: "lg",
    style: {
      position: 'relative',
      top: '1px'
    }
  })));
}

MobilePdfToolbar.displayName = "MobilePdfToolbar";
var MobilePdfToolbar$1 = observer(MobilePdfToolbar);
export default MobilePdfToolbar$1;